import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
});

$(window).on('load resize', function () {
  /**
  * ヘッダーの高さ
  */
  const $headerHeight = $('.l-header').height();
  $('.l-main').css('margin-top', $headerHeight);
  $('.l-drawer').css('padding-top', $headerHeight);

  /**
  * 画面幅1280px以上
  */
  const $windowWidth = $(window).width();
  const $fixedWidth = 1280;
  if ($fixedWidth <= $windowWidth) {
    $('.l-header').removeClass('is-open');
    $('.js-hamburger').removeClass('is-open');
    $('.js-drawer').removeClass('is-open');
  }
});